// extracted by mini-css-extract-plugin
export default {"l":"_5be54ccb61"};